import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

const FAQS = [
  {
    q: "What exactly is a dry hire mobile bar?",
    a: "You supply the alcohol — the bottles you and your guests love. We supply everything else: TABC certified bartenders, mixers and soda, fresh garnish, glassware, bar tools and ice. It's the easiest way to serve great drinks without stocking a full bar.",
    test: "faq-dry-hire",
  },
  {
    q: "Do you offer an alcohol-free option?",
    a: "Yes — The Zero Proof. It's our $400 package for up to 50 guests with the same TABC certified bartenders, glassware and garnish station, swapped to a crafted mocktail menu — matcha, tea infusions and fresh lemonades. Perfect for dry venues, brunches, baby showers and anyone skipping the spirits.",
    test: "faq-zero-proof",
  },
  {
    q: "Do I need to provide ice?",
    a: "No — we bring the ice. That's one more line off your shopping list.",
    test: "faq-ice",
  },
  {
    q: "What does my venue need to have?",
    a: "Just access to a power source. We bring our own extension cords, bar tools and everything in between. If you add the portable bar, we'll also need a spot for it — roughly the size of a large table.",
    test: "faq-power",
  },
  {
    q: "What happens if the weather turns?",
    a: "For outdoor events, we'll need the setup moved indoors or under a carport if the weather doesn't cooperate. If that's not possible, we'll gladly postpone or cancel — see our cancellation policy above in the booking section.",
    test: "faq-weather",
  },
  {
    q: "How does payment work?",
    a: "Instant booking takes a 40% deposit to lock your date, and the balance is settled from your final quote. Cancel 14+ days before your event and the deposit is fully refunded. Prefer to talk first? Use 'Get a quote' and we'll build your numbers within 24 hours.",
    test: "faq-payment",
  },
  {
    q: "How long does the bar stay open?",
    a: "Every party includes a 5-hour minimum, and that covers setup and breakdown too. Need longer? Extra hours can be added when you build your bar.",
    test: "faq-duration",
  },
  {
    q: "Where do you serve?",
    a: "We cover the La Cantera to Boerne area. Anything outside a 30-mile radius is subject to an upcharge — just tell us where you are and we'll sort it out.",
    test: "faq-area",
  },
  {
    q: "Can we create our own signature drinks?",
    a: "Absolutely — The Full Pour includes 3 signature cocktails crafted for your event, and you can add more. Share your theme, favorite spirits or a pinterest board in the extra information box and we'll design pours to match.",
    test: "faq-signature",
  },
  {
    q: "How far in advance should I book?",
    a: "The earlier the better — popular weekends go first. Planning something last minute? Text us anyway; if the date's free, it's yours.",
    test: "faq-lead-time",
  },
];

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-cream px-5 py-24 sm:px-8 lg:py-32">
      <div className="mx-auto max-w-4xl">
        <Reveal>
          <span className="eyebrow text-espresso/50">FAQ</span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl">
            Good <em className="italic text-rose">questions</em>
          </h2>
        </Reveal>

        <Reveal delay={0.2}>
          <Accordion type="single" collapsible className="mt-12" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.test} value={`item-${i}`} className="border-espresso/10" data-testid={`faq-item-${i + 1}`}>
                <AccordionTrigger className="py-5 text-left font-display text-xl hover:no-underline sm:text-2xl" data-testid={f.test}>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm leading-relaxed text-espresso/70 sm:text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}